<script setup>
import { defineProps, defineEmits, computed} from "vue";
import UtilNumber from "../../../../utils/UtilNumber"

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "revisandoPedido",
    "pedidoDeCompra",
    "item",
    "itemTipo",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:item",
    "update:removeItem",
]);

//==================================================================//
//=========================== Altera Item ==========================//
//==================================================================//

const alteraItem = (update = {}) =>{

    emits('update:item', update);

};

//==================================================================//
//=========================== Remove Item ==========================//
//==================================================================//

const removeItem = (update = {}) =>{

    emits('update:removeItem', update);

};

//==================================================================//
//=================== Valor Disponivel Formatado ===================//
//==================================================================//

let valorDisponivelFormatado = computed(()=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(UtilNumber.clamp(props?.item?.osItemValorDisponivel,-999999999,999999999));

});

//==================================================================//
//============== Valor Total Com Impostos Formatado ================//
//==================================================================//

let valorTotalFormatado = computed(()=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(UtilNumber.clamp(props?.item?.osItemPrecoTotalComImpostosComIPI,-999999999,999999999));

});

//==================================================================//
//============================= Abre Item ==========================//
//==================================================================//

const abreItem = ()=>{

    alteraItem({
        aberto: !props?.item?.aberto,
    })

};

//==================================================================//
//======================= Ao Remover Item Novo =====================//
//==================================================================//

const aoRemoverItemNovo = ()=>{

    alteraItem({
        status: "Valido",
        remover: !props?.item?.remover,
    })

};

//==================================================================//
//===================== Ao Remover Item Rascunho ===================//
//==================================================================//

const aoRemoverItemRascunho = () => {

    if(!props?.item?.adicionado){
        return;
    }

    removeItem(props?.item);

};

//==================================================================//
//========================= Item Status Cor ========================//
//==================================================================//

const itemStatusCor = computed(()=>{

    if(props?.item?.status == "Leitura"){
        return "gray"
    }

    if(props?.item?.status == "Salvo"){
        return "green"
    }

    if(props?.item?.status == "Valido"){
        return "orange"
    }

    return "red"

});

//==================================================================//
//==================== Item Novo Remover Label =====================//
//==================================================================//

const itemNovoRemoverLabel = computed(()=>{

    return props?.item?.remover ? "✓ Sim" : "Não"

});

//==================================================================//
//===================== Item Novo Remover Cor ======================//
//==================================================================//

const itemNovoRemoverCor = computed(()=>{

    if(props?.item?.remover == true){
        return "#212121"
    }

    return "red"

});

</script>

<template>

<tr
    class="c-linha"
    @click="abreItem"
>

    <td
        class="c-celula"
    >

        <v-icon
            v-if="props?.item?.aberto == false"
            color="blue-grey darken-2"
        >
            mdi-chevron-down
        </v-icon>

        <v-icon
            v-else
            color="blue-grey darken-2"
        >
            mdi-chevron-up
        </v-icon>
    
    </td>

    <td class="c-celula">

        <v-chip
            :color="itemStatusCor"
            dark
        >
            {{ props?.item?.status }}
        </v-chip>

    </td>

    <td class="c-celula">

        <v-chip
            v-if="props.itemTipo == 'Novo'"
            @click.stop="aoRemoverItemNovo"
            class="c-botao-remover-item"
            :color="itemNovoRemoverCor"
            dark
        >
            {{ itemNovoRemoverLabel }}
        </v-chip>

        <v-chip
            v-else-if="props.itemTipo == 'Rascunho'"
            @click.stop="aoRemoverItemRascunho"
            class="c-botao-remover-item"
            color="red"
            dark
        >
            <v-icon>mdi-trash-can-outline</v-icon>
        </v-chip>

    </td>

    <td class="c-celula">
        {{ props?.item?.jobCodigo }}
    </td>
    
    <td class="c-celula">
        {{ props?.item?.osCodigo }}
    </td>
    
    <td class="c-celula">
        {{ props?.item?.osItemSequencia }}
    </td>

    <td class="c-celula">
        {{ props?.item?.osItemItemCodigo }}
    </td>
    
    <td class="c-celula c-celula__descricao">
        {{ props?.item?.osItemDescricao }}
    </td>
    
    <td class="c-celula">
        {{ props?.item?.osItemDataSolicitacao }}
    </td>
    
    <td class="c-celula">
        {{ props?.item?.osItemDataNecessidade }}
    </td>

    <td class="c-celula">
        {{ props?.item?.osItemDataLiberacaoCompras }}
    </td>

    <td class="c-celula">
        {{ props?.item?.osItemDataEntrega}}
    </td>
    
    <td class="c-celula">
        {{ props?.item?.osItemQuantidadeCompra }}
    </td>
    
    <td class="c-celula">
        {{ props?.item?.osItemUnidadeCompra?.sigla }}
    </td>
    
    <td class="c-celula">
        R$ {{ valorDisponivelFormatado }} 
    </td>
    
    <td class="c-celula"> 
        R$ {{ valorTotalFormatado }}
    </td>
    
    <td class="c-celula">
        {{ props?.item?.osItemStatus }}
    </td>

</tr>

</template>

<style scoped>

.c-linha{
    cursor: pointer;
}

.c-linha:hover{
    background: #eeeeee;
}

.c-linha > .c-celula{
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-celula{
    padding: 0 16px;
    font-size: 0.875rem;
    height: 48px;
    vertical-align: middle;
}

.c-botao-remover-item{
    cursor: pointer;
}

.c-celula__descricao{
    white-space: normal;
    margin: 0px !important;
}

</style>